import React from 'react';
import { BoxIcon } from 'lucide-react';
interface CategoryCardProps {
  id: string;
  name: string;
  icon: BoxIcon;
  disabled?: boolean;
  onClick: (id: string) => void;
}
export function CategoryCard({
  id,
  name,
  icon: Icon,
  disabled = false,
  onClick
}: CategoryCardProps) {
  return <button onClick={() => !disabled && onClick(id)} disabled={disabled} className={`
        flex flex-col items-center justify-center p-4 bg-white rounded-xl border shadow-sm transition-all duration-200 h-full w-full text-center relative
        ${disabled ? 'border-gray-100 opacity-60 cursor-not-allowed' : 'border-gray-100 hover:shadow-md hover:border-teal-200 hover:bg-teal-50/30 group'}
      `} data-id="element-12">
      {disabled && <span className="absolute top-2 right-2 text-[10px] font-semibold px-2 py-0.5 bg-gray-100 text-gray-500 rounded-full border border-gray-200" data-id="element-13">
          Coming Soon
        </span>}

      <div className={`
        p-3 rounded-full mb-3 transition-transform duration-200
        ${disabled ? 'bg-gray-100 text-gray-400' : 'bg-teal-50 text-teal-600 group-hover:bg-teal-100 group-hover:scale-110'}
      `} data-id="element-14">
        <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-15" />
      </div>

      <span className={`
        text-sm font-medium line-clamp-2
        ${disabled ? 'text-gray-400' : 'text-gray-700 group-hover:text-teal-800'}
      `} data-id="element-16">
        {name}
      </span>
    </button>;
}